import type { IUiDialogHookCustomContent } from '@experiences/interfaces';
import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme } from '@mui/styles';
import { FontVariantToken } from '@uipath/apollo-core';
import { ApButton } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

export const ConnectedModelsSuccessDialogBody: React.FC<IUiDialogHookCustomContent> = ({ closeDialog }) => {
    const { formatMessage: translate } = useIntl();
    const theme = useTheme();

    return (
        <UiStack
            direction='column'
            align='center'
            justify='center'
            gap={SpacingToken.M}
            py={SpacingToken.L}>
            <CheckCircleIcon
                style={{
                    color: theme.palette.semantic.colorSuccessIcon,
                    fontSize: '48px',
                }}
            />
            <UiText
                variant={FontVariantToken.fontSizeLBold}
                style={{ textAlign: 'center' }}>
                {translate({ id: 'CLIENT_BYO_LLM_VALIDATION_SUCCESS_TITLE' })}
            </UiText>
            <UiText style={{ textAlign: 'center' }}>
                {translate({ id: 'CLIENT_BYO_LLM_VALIDATION_SUCCESS_SUBTITLE' })}
            </UiText>
            <ApButton
                variant='primary'
                label={translate({ id: 'CLIENT_DONE' })}
                onClick={() => closeDialog()}
                style={{ marginTop: SpacingToken.M }}
                data-cy="validation-success-done-button"
            />
        </UiStack>
    );
};
